import { ApiService } from '../../app-lite/api/api.service';

import XeroCountryHtml from './xero.country.html';
import XeroSignupHtml  from './xero.signup.html';

export function XeroStates (
  $stateProvider: ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller  : 'XeroCountryCtrl',
    controllerAs: '$ctrl',
    name        : 'app.xero-country',
    url         : '/xero-country',
    resolve     : {
      countries: ( workshopAPI : ApiService ) => {
        return workshopAPI.get('/system/country_types', null, null, {
          bypass: true
        });
      }
    },
    templateUrl: XeroCountryHtml,
  })
  .state({
    controller    : 'XeroSignupCtrl',
    controllerAs  : '$ctrl',
    name          : 'app.xero-signup',
    reloadOnSearch: false,
    resolve       : {
      countries: ( workshopAPI : ApiService ) => {
        return workshopAPI.get('/system/country_types', null, null, {
          bypass: true
        });
      }
    },
    templateUrl: XeroSignupHtml,
    url        : '/xero-signup?code&country',
  });
}